import enMessages from '@/../messages/en.json';

export const FORM_ERROR = {
  NOT_VALID_EMAIL: {
    status: 400,
    sys_code: '9800002',
    message: enMessages.formBuilder.error.NOT_VALID_EMAIL
  },
  NOT_VALID_RESERVATION_EMAIL: {
    status: 400,
    sys_code: '9800003',
    message: enMessages.formBuilder.error.NOT_VALID_RESERVATION_EMAIL
  },
  RESERVATION_NOT_FOUND: {
    status: 400,
    sys_code: '9800007',
    message: enMessages.formBuilder.error.RESERVATION_NOT_FOUND
  },
  MISSING_RESERVATION_DATE: {
    status: 400,
    sys_code: '9800008',
    message: enMessages.formBuilder.error.MISSING_RESERVATION_DATE
  },
  MISSING_RESERVATION_TIME: {
    status: 400,
    sys_code: '9800009',
    message: enMessages.formBuilder.error.MISSING_RESERVATION_TIME
  },
  INVALID_INPUT_FORMAT: {
    status: 400,
    sys_code: '9800010',
    message: 'Invalid input format. Please check the format and try again. '
  }
};
